import React from 'react';
import { Button, ButtonSize } from './button';

export type ButtonSecondaryColors = 'light';

type ButtonSecondaryProps = {
  children: React.ReactNode;
  color?: ButtonSecondaryColors;
  onClick?: () => void;
  href?: string;
  className?: string;
  disabled?: boolean;
  type?: 'submit';
  size?: ButtonSize;
} & React.HTMLAttributes<HTMLElement>;

export const ButtonSecondary = ({
  children,
  onClick,
  href,
  color = 'light',
  className,
  disabled,
  type,
  size,
  ...props
}: ButtonSecondaryProps) => (
  <Button
    color={color}
    onClick={onClick}
    {...(href ? { href } : { disabled, type })}
    className={className}
    disabled={disabled}
    type={type}
    size={size}
    {...props}
  >
    {children}
  </Button>
);
